import React, { useEffect, useState, useRef } from 'react';
import { notification, Modal, Popover, Button, Button as ANTButton, Tooltip, Space, Skeleton } from 'antd';
import Table from 'components/Table';
import { useSelector } from 'react-redux';
import '../style.css';
import http from 'utils/http';
import { useQuery } from 'react-query';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { PageHeader } from '../../../components/Atom/PageHeader';
import { ResetButton, FilterButton } from '../../../components/Atom/Button';
import { ReloadOutlined, UploadOutlined, DollarOutlined } from '@ant-design/icons';
import Filter from './assets/filter';
import SearchField from '../../../components/Atom/SearchField/index';
import { getAllPlans, deletePlan, getSinglePlan } from 'api/subscriptions';
import { useNavigate, useLocation } from 'react-router-dom';
import { TIMEZONES } from 'utils/constant';
import { convertToSubscriptionTimezone, handleDateRangeFormat, checkUserPermissions, handleStateByPassData, formatAmount } from 'utils/services';
import { USER_ROLES } from 'utils/constant';
import CreatePlan from './createPlan';
import ShortenId from 'components/Atom/ShortenId';
export const Plan = () => {
  const store = useSelector((state) => state?.company?.store);
  const [deletePlanModal, setDeletePlanModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [planModalData, setPlanModalData] = useState({});
  const [isPlanDeleting, setIsPlanDeleting] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [filterToggle, setFilterToggle] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [delayTimer, setDelayTimer] = useState();
  const [recordId, setRecordId] = useState('');
  const [openBulkPlanModel, setOpenBulkPlanModel] = useState(false);
  const [selectedCSVFile, setSelectedCSVFile] = useState(null);
  const [isBulkPlanCreating, setIsBulkPlanCreating] = useState(false);
  const hiddenFileInput = useRef(null);
  const tableContainerRef = useRef(null);

  const handleDeletePlan = async (id) => {
    setIsPlanDeleting(true);
    const response = await deletePlan(planModalData?.store_id, id);
    if (response?.data?.success) {
      setDeletePlanModal(false);
      refetch();
    }
    setIsPlanDeleting(false);
  };

  const fetchPlanData = async (planData) => {
    setDataLoading(true);
    const response = await getSinglePlan(planData?.store_id, planData?.plan_id);
    const data = response?.data?.data;
    setPlanModalData(data);
    setDataLoading(false);
  };

  const handleOpen = () => {
    setOpen(!open);
    setIsEdit(false);
    setPlanModalData({});
  };
  const columnsData = [
    {
      title: 'Plan ID',
      render: (value) => <ShortenId value={value?.plan_id} />,
      key: 'plan_id',
      fixed: 'left',
    },
    {
      title: 'Price',
      render: (value) => `${value?.currency || ''} ${formatAmount(value?.amount || '0', value?.currency)}`,
      key: 'amount',
    },
    {
      title: 'Interval',
      render: (value) => value?.interval || '0',
      key: 'interval',
    },

    {
      title: <Tooltip title='Every repeat after interval'>Every</Tooltip>,
      render: (value) => value?.every || '0',
      key: 'every',
    },
    {
      title: 'Active',
      render: (value) => (value?.active === true ? 'Yes' : 'No'),
      key: 'active',
    },

    {
      title: 'Time',
      render: (value) => value?.updatedAt,
      key: 'updatedAt',
    },
    ...(checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_SUBSCRIPTION_USER])
      ? [
          {
            title: 'Action',
            key: 'action',
            render: (planData, index) => {
              return (
                <div key={index} className='flex items-center gap-2'>
                  <>
                    <div
                      className='table-action-btn flex items-center justify-center'
                      onClick={() => {
                        fetchPlanData(planData);
                        setOpen(true);
                        setIsEdit(true);
                      }}
                      style={{ cursor: 'pointer' }}>
                      Update
                    </div>
                    <div
                      type='primary'
                      className='table-action-btn'
                      onClick={() => {
                        setPlanModalData(planData), setDeletePlanModal(true);
                      }}
                      style={{ cursor: 'pointer' }}>
                      Delete
                    </div>
                  </>
                </div>
              );
            },
          },
        ]
      : []),
  ];
  const [search, setSearch] = useState('');

  const fetchData = async (queryParams) => {
    try {
      const paramsData = { offset: queryParams?.offset, limit: queryParams?.limit };
      if (queryParams?.search !== '') {
        paramsData['search_key'] = queryParams?.search;
      }
      const formattedData = filtersDataValues(queryParams?.filtersData);
      const params = { ...paramsData, ...formattedData, ...(store?.isSelected && { store_id: store?._id }), xap_request: true };
      const response = await getAllPlans(params);
      const timezone = store?.settings?.timezone || TIMEZONES?.PKT;
      const result = await convertToSubscriptionTimezone(response?.data?.data, timezone, 'plans');
      response.data.data = result;
      return response?.data?.data;
    } catch (err) {
      console.log(err);
    }
  };
  const { data, refetch, isLoading, isFetching } = useQuery('plans', () => fetchData(queryParams), {
    enabled: false,
    manual: true,
  });
  const [queryParams, setQueryParams] = useState({
    offset: 0,
    limit: 20,
    search: '',
    currentPage: 1,
  });
  const [trigerApi, setTrigerApi] = useState(true);
  const handleFileSelectionModel = (isBulk) => {
    if (store?.isSelected) {
      if (isBulk) {
        setOpenBulkPlanModel(true);
      } else {
        setOpen(true);
      }
    } else {
      notification.error({
        message: 'Store Selection Required',
        description: 'Please select a store from the drop-down menu above to continue',
        placement: 'bottomRight',
      });
    }
  };

  const handleBulkPlan = async () => {
    if (!selectedCSVFile) {
      notification.error({ message: 'Please select a CSV file', placement: 'bottomRight' });
      return;
    }
    try {
      setIsBulkPlanCreating(true);
      const signedUrlResponse = await http.get(`/public/v1/plan/signed-url?store_id=${store?._id}&fileName=${encodeURIComponent(selectedCSVFile?.name)}`);
      if (!signedUrlResponse?.data?.data) {
        notification.error({ message: 'Failed to upload file.Please try again', placement: 'bottomRight' });
        return;
      }
      const uploadResponse = await fetch(signedUrlResponse?.data?.data, {
        method: 'PUT',
        headers: {
          'Content-Type': 'text/csv',
        },
        body: selectedCSVFile,
      });
      if (uploadResponse?.ok) {
        const response = await http.post(`/public/v1/plan/bulk-plan-upload?store_id=${store?._id}`, { filePath: selectedCSVFile?.name });
        setSelectedCSVFile(null);
        setOpenBulkPlanModel(false);
        setIsBulkPlanCreating(false);
        notification.success({ message: response?.data?.data?.message || 'We are currently adding your Plans, and it will be completed soon.', placement: 'bottomRight' });
      } else {
        setIsBulkPlanCreating(false);
        notification.error({ message: 'Something went wrong. Please try again', placement: 'bottomRight' });
      }
    } catch (err) {
      setIsBulkPlanCreating(false);
      notification.error({ message: err?.response?.data?.message || 'Something went wrong', placement: 'bottomRight' });
    }
  };
  const handleCSVUploadClick = (event) => {
    hiddenFileInput?.current?.click();
  };
  const handleCSVFileUpload = (e) => {
    const fileData = e?.target?.files[0];
    if (fileData?.type === 'text/csv') {
      setSelectedCSVFile(fileData);
    } else {
      notification.error({ message: 'Please upload csv file', placement: 'bottomRight' });
    }
  };

  useEffect(() => {
    if (location?.state?.isRedirection && data) {
      setSearch(location?.state?.searchValue);
      setRecordId(location?.state?.id);
      navigate(location.pathname, { replace: true });
      const data = handleStateByPassData(location?.state?.filtersData, true);
      if (!data) {
        refetch();
      }
      setQueryParams(data);
      setTimeout(() => {
        if (tableContainerRef?.current && location?.state?.id) {
          const row = document?.querySelector(`.custom-row-class.highlighted-row`);
          if (row) {
            row?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      }, 10);
      return;
    } else if (location?.state?.isRedirection) {
      navigate(location.pathname, { replace: true });
    }
    refetch();
  }, [trigerApi, store]);
  const filtersDataValues = (data) => {
    let filtersData = {};
    if (data?.date_range) {
      const timezone = store?.isSelected ? store?.settings?.timezone || TIMEZONES.PKT : null;
      const { start_date, end_date } = handleDateRangeFormat(data?.date_range, timezone);
      filtersData.start_date = start_date;
      filtersData.end_date = end_date;
    }
    filtersData.status = data?.subscription_status ?? null;
    return filtersData;
  };
  const getSearch = async (e) => {
    if (e === '' || e == null) {
      notification?.error({ message: 'Please enter details for search', placement: 'bottomRight' });
    } else {
      setQueryParams((pre) => ({ ...pre, currentPage: 1, offset: 0, search: e }));
      setTrigerApi(!trigerApi);
    }
  };
  const handlePagePageChange = (page, pageSize) => {
    if (queryParams?.limit !== pageSize) {
      setQueryParams((pre) => ({ ...pre, limit: pageSize, offset: 0, currentPage: 1 }));
      setTrigerApi(!trigerApi);
    } else {
      const countOffset = page * queryParams?.limit - queryParams?.limit;
      setQueryParams((pre) => ({ ...pre, limit: pageSize, offset: countOffset, currentPage: page }));
      setTrigerApi(!trigerApi);
    }
  };
  const handleSearchData = () => {
    if (delayTimer) {
      clearTimeout(delayTimer);
    }
    const newTimer = setTimeout(() => {
      handleRefresh();
    }, 1500);
    setDelayTimer(newTimer);
  };
  const handleRefresh = (isRefresh = true) => {
    if (isRefresh) {
      setSearch(null);
    } else {
      setIsFilterModalOpen(false);
    }
    setQueryParams((pre) => ({ ...pre, offset: 0, currentPage: 1, search: '', filtersData: isRefresh ? pre?.filtersData : null }));
    setTrigerApi(!trigerApi);
  };
  const handleCloseFilterModel = () => {
    setIsFilterModalOpen(!isFilterModalOpen);
  };
  const handleFiltersSearch = (data) => {
    setQueryParams((pre) => ({ ...pre, offset: 0, currentPage: 1, filtersData: data }));
    setTrigerApi(!trigerApi);
  };
  const filterToggler = () => {
    setFilterToggle(true);
  };
  const handleReset = () => {
    setQueryParams((prev) => ({ ...prev, offset: 0, currentPage: 1, filtersData: {} }));
    setTrigerApi(!trigerApi);
    setIsFilterModalOpen(false);
  };
  const popOverContent = (
    <div className='popOver'>
      <div className='popover_header mt-2 mb-3 flex items-center gap-2'>
        <span style={{ fontWeight: '700', color: '#262626' }}>Filter</span>
        <div className='flex items-center text-[#000000] gap-2 cursor-pointer' onClick={() => handleReset()}>
          <ReloadOutlined style={{ fontSize: '16px' }} />
          <span style={{ color: '#000000', fontSize: '14px', lineHeight: '24px' }}>Reset All</span>
        </div>
      </div>
      <div className='intentFilters'>
        <Filter filterToggler={filterToggler} filtersData={queryParams?.filtersData} onSearch={handleFiltersSearch} handleClose={handleCloseFilterModel} />
      </div>
    </div>
  );
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Plans',
      },
    ],
  };
  const handleSearch = (e) => {
    if (delayTimer && e !== '' && e !== null) {
      clearTimeout(delayTimer);
    }
    setSearch(e?.target?.value?.trim());
  };
  const handleRowHover = () => {
    setRecordId('');
  };
  return (
    <div style={{ padding: '0px', width: '100%' }}>
      <div className='header-container'>
        <Breadcrumbs {...breadcrumbProps} />
        <div className='headerPage'>
          <div className='mb-0'>
            <PageHeader label='Plans' button={<ResetButton onClick={isFetching ? '' : handleRefresh} loading={isFetching} />} />
          </div>

          {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_SUBSCRIPTION_USER]) && (
            <div className='flex txn-btn'>
              <Button
                disabled={isBulkPlanCreating}
                className='custom-btns p-2 flex items-center'
                onClick={() => {
                  handleFileSelectionModel(true);
                }}>
                <UploadOutlined className='inline text-base' /> <span className='text-base'> Create Bulk Plan</span>
              </Button>
              <div>
                <Button
                  className='primaryBtn mr-0 rounded-lg create_button'
                  onClick={() => {
                    handleFileSelectionModel(false);
                  }}>
                  <span className='text-base'>Create Plan</span>
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='actionPanel'>
        <div className='headerContainer' style={{ width: '100%' }}>
          <Popover
            className={isFilterModalOpen ? 'filter-active filterPopover' : filterToggle ? 'text-base activeFilterToggler filterPopover' : 'text-base filterPopover'}
            trigger='click'
            placement='bottomLeft'
            content={popOverContent}
            open={isFilterModalOpen}
            destroyTooltipOnHide
            onOpenChange={() => {
              handleCloseFilterModel();
            }}>
            <FilterButton onClick={() => setIsFilterModalOpen(true)}>
              <div className='text-base'>Filter</div>
            </FilterButton>
          </Popover>
          <div className='searchInput' style={{ width: '100%' }}>
            <SearchField
              handleOnChange={handleSearch}
              value={search}
              handlePressEnter={getSearch}
              onReset={handleSearchData}
              placeholder={'Search by Plan ID, Product ID, Currency, Interval'}
              loading={!!(isFetching && search)}
              dropdown={{ show: false }}
              enableSearchBtn={true}
            />
          </div>
        </div>
      </div>
      <br />
      <div className='overflow-x-auto custom-table' ref={tableContainerRef}>
        <Table
          loading={isLoading}
          dataSource={data?.products}
          columns={columnsData}
          scroll={{ x: 'auto' }}
          onRow={(record) => {
            return {
              onClick: (event) => {
                const { className } = event?.target;
                if (!className?.includes('table-action-btn')) {
                  navigate(`/subscriptions/plan/${record?.plan_id}`, { state: { record, id: record?.plan_id, filtersData: handleStateByPassData(queryParams), searchValue: search } });
                }
              },
              onMouseEnter: handleRowHover,
              className: `custom-row-class ${recordId === record?.plan_id ? 'highlighted-row' : ''}`,
            };
          }}
          totalLenght={data?.count}
          pagingation={{ handlePageChange: handlePagePageChange, perPageSize: queryParams?.limit, page: queryParams?.currentPage }}
        />
      </div>
      <Modal
        /* className='bin-modal' */
        open={deletePlanModal}
        centered
        width={400}
        onCancel={() => {
          setDeletePlanModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isPlanDeleting }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Delete Plan</header>
        <div className='mb-8'>
          Are you sure you want to delete this Plan<span>{'?'}</span>
        </div>
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setDeletePlanModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='DeleteBtn ml-4 rounded-lg' block onClick={() => handleDeletePlan(planModalData?.plan_id)} loading={isPlanDeleting}>
            Confirm
          </Button>
        </div>
      </Modal>
      <Modal trigger='click' centered open={open} width={window.innerWidth < 768 ? 350 : 600} footer={null} destroyOnClose onCancel={handleOpen}>
        <div className='mobileVersion'>
          <div className='font-semibold text-base' style={{ marginBottom: '12px' }}>
            <span className='createIcon'>
              <DollarOutlined />
            </span>
          </div>
          <div className='font-semibold text-base' style={{ marginBottom: '12px' }}>
            {!isEdit ? 'Add new Plan' : 'Update Plan'}
          </div>
          {dataLoading ? (
            <div style={{ width: '100%' }}>
              <Skeleton active />
            </div>
          ) : (
            <CreatePlan handleOpen={handleOpen} refetch={refetch} planData={planModalData} isEdit={isEdit} />
          )}
        </div>
      </Modal>
      <Modal
        trigger='click'
        centered
        width={window.innerWidth < 768 ? 350 : 500}
        open={openBulkPlanModel}
        footer={null}
        destroyOnClose
        className='exportModalContainer bulkExportModal'
        onCancel={() => {
          setSelectedCSVFile(null);
          setOpenBulkPlanModel(false);
        }}>
        <div>
          <div className='font-semibold text-base mb-4'>Create Bulk Plan</div>
        </div>
        <div className='exportModal exportExcelCsvModal'>
          <ANTButton className='uploadBinsBtn rounded-lg' onClick={handleCSVUploadClick} icon={<UploadOutlined style={{ fontSize: '16px' }} />}>
            Upload CSV File
          </ANTButton>
          <p style={{ marginTop: '5px', marginLeft: '5px', color: selectedCSVFile?.name ? 'blue' : 'gray', ...(!selectedCSVFile?.name && { fontStyle: 'italic' }) }}>{selectedCSVFile?.name}</p>
          <input type='file' accept='.csv' ref={hiddenFileInput} onChange={handleCSVFileUpload} style={{ display: 'none' }} />
        </div>
        <div style={{ display: 'flex', marginTop: '5px' }}>
          <p>Please download the template file by clicking </p>
          <a href='https://xap.xstak.com/bulk-plan-template-file.csv' target={'_blank'} style={{ color: 'blue', marginLeft: '4px', textDecoration: 'underline', cursor: 'pointer' }}>
            here
          </a>
        </div>
        <div className='binClass modal-button' style={{ display: 'flex', justifyContent: 'end', gap: '5px', alignItems: 'center', marginTop: '16px' }}>
          <Button style={{ color: '#fff' }} loading={isBulkPlanCreating} disabled={!selectedCSVFile?.name} className='parentThree customExport' onClick={handleBulkPlan}>
            Submit
          </Button>
        </div>
      </Modal>
    </div>
  );
};
